// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const qwilfish: PokeData = {
  "id": 211,
  "name": "qwilfish",
  "height": 5,
  "weight": 39,
  "base_experience": 88,
  "types": [
    PokeType.WATER,
    PokeType.POISON
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "poison-sting",
    "pin-missile",
    "water-gun",
    "hydro-pump",
    "toxic",
    "harden",
    "minimize",
    "bubble",
    "spikes",
    "destiny-bond",
    "rollout",
    "stockpile",
    "spit-up",
    "revenge",
    "brine",
    "acupressure",
    "toxic-spikes",
    "poison-jab",
    "aqua-tail",
    "fell-stinger"
  ],
  "moves": [
    "tackle",
    "pin-missile",
    "hydro-pump",
    "bubble",
    "brine",
    "toxic-spikes",
    "poison-jab",
    "aqua-tail",
    "whirlpool",
    "poison-fang",
    "acid",
    "water-spout",
    "aqua-cutter"
  ],
  "evolution_chain": {
    "id": 106,
    "item": null,
    "species": [
      {
        "name": "qwilfish",
        "order": 242,
        "types": [
          PokeType.WATER,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "overqwil",
        "order": 904,
        "types": [
          PokeType.DARK,
          PokeType.POISON
        ],
        "evolves_from_species_id": 211,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "barb-barrage"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.STRONG_STYLE_MOVE
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 67.5,
    "speed": 85,
    "ability_power": 95
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
